import { Record } from 'immutable';

export const TAX_LINE_ITEMS_REDUCER_KEY = 'taxLineItemsStore';

export const mkTaxLineItem = Record({
  id: null,
  formId: null,

  txfId: null,

  name: null,
  description: null,

  displayOrder: null,
});
